import { IllustratedMessage } from '@spectrum-web-components/illustrated-message';
import styles from './illustrated-message.lit.scss';

Object.defineProperty(IllustratedMessage, 'styles', {
  value: [...IllustratedMessage.styles, styles],
  writable: false,
});
customElements.define('sp-illustrated-message', IllustratedMessage);
